import React from "react";
import { Box, Grid, Typography, Link, Divider } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import YouTubeIcon from "@mui/icons-material/YouTube";
import PhoneIcon from "@mui/icons-material/Phone";
import EmailIcon from "@mui/icons-material/Email";
import { useNavigate } from "react-router-dom";

const Footer = () => {
  const navigate = useNavigate();

  const menuLeft = [
    { text: "TRANG CHỦ", path: "/" },
    { text: "GIỚI THIỆU", path: "/gioithieu" },
    { text: "LƯỢC SỬ", path: "/luocsu" },
    { text: "CHIẾN KÝ", path: "/chienki" },
  ];

  const menuRight = [
    { text: "HỒI ÂM", path: "/hoiam" },
    { text: "PHẢN HỒI", path: "/phanhoi" },
  ];

  return (
    <Box sx={{ backgroundColor: "#8a0000", color: "white", pt: 6, fontSize: 14 }}>
      <Box sx={{ maxWidth: 1300, mx: "auto", px: { xs: 2, md: 4 } }}>
        {/* Top Section */}
        <Grid
          container
          alignItems="center"
          justifyContent="space-between"
        >
          {/* Logo */}
          <Grid item xs={12} md="auto" textAlign={{ xs: "center", md: "left" }}>
            <Box display="flex" alignItems="center" justifyContent={{ xs: "center", md: "flex-start" }}>
              <img
                src={`${process.env.REACT_APP_STATIC_URL}/uploads/logo/text_nhat.png`}
                alt="Logo"
                style={{ height: 130, marginRight: 10 }}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md="auto">
            {/* Box bọc ngoài để căn giữa trên mobile */}
            <Box
              sx={{
                display: "flex",
                justifyContent: { xs: "center", md: "flex-end" }, // mobile center, pc phải
              }}
            >
              {/* Cụm menu co lại theo content */}
              <Box
                sx={{
                  display: "grid",
                  gridTemplateColumns: { xs: "auto auto", md: "1fr 1fr" },
                  rowGap: { xs: 1, md: 0 },
                  columnGap: { xs: 4, md: 0 },
                  width: { xs: "max-content", md: 250 }, // mobile co cụm, pc giữ 250px
                }}
              >
                {[...menuLeft, ...menuRight].map((item) => (
                  <Link
                    key={item.text}
                    component="button"
                    onClick={() => navigate(item.path)}
                    underline="hover"
                    sx={{
                      color: "white",
                      textDecorationColor: "white",
                      textAlign: "left", // chữ luôn căn trái
                      px: 1,
                      py: 0.5,
                    }}
                  >
                    {item.text}
                  </Link>
                ))}
              </Box>
            </Box>
          </Grid>



        </Grid>

        {/* Divider */}
        <Divider sx={{ borderColor: "red", my: 4 }} />

        {/* Bottom Section */}
        <Grid container alignItems="center" justifyContent="space-between">
          {/* Contact */}
          <Grid item xs={12} md="auto" mb={4}>
            <Box
              display="flex"
              flexDirection={{ xs: "column", sm: "row" }}
              alignItems="flex-start" // luôn căn trái trên mọi màn hình
              justifyContent="flex-start"
              gap={2}
            >
              <Box display="flex" alignItems="center" gap={1}>
                <PhoneIcon fontSize="small" />
                <Typography>0367 633 608</Typography>
              </Box>
              <Box display="flex" alignItems="center" gap={1}>
                <EmailIcon fontSize="small" />
                <Typography>tiengvongsuviet@gmail.com</Typography>
              </Box>
            </Box>
          </Grid>

          {/* Social Icons */}
          <Grid item xs={12} md="auto" mb={4}>
            <Box
              display="flex"
              justifyContent={{ xs: "flex-start", md: "flex-end" }} // mobile: căn trái, PC: giữ nguyên căn phải
              alignItems="center"
              gap={2}
              mt={{ xs: 2, md: 0 }}
              mr={{ md: 7 }}
            >
              <Link href="https://facebook.com" target="_blank" rel="noopener noreferrer" sx={{ color: "white" }}>
                <FacebookIcon />
              </Link>
              <Link href="https://youtube.com" target="_blank" rel="noopener noreferrer" sx={{ color: "white" }}>
                <YouTubeIcon />
              </Link>
              <Box
                component="a"
                href="https://tiktok.com/@yourproject"
                target="_blank"
                rel="noopener noreferrer"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: 32,
                  height: 32,
                  color: "white",
                  textDecoration: "none",
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 256 256"
                  width="24"
                  height="24"
                  fill="currentColor"
                >
                  <path d="M189.3 80.6a65.8 65.8 0 01-23-4.5v62.9a61.2 61.2 0 11-61.2-61.2c1.3 0 2.6 0 3.9.1v32.7a28.5 28.5 0 1033.6 28v-98.3h32.7a33.9 33.9 0 002.4 12.9 33.6 33.6 0 0018.6 18.5 33.9 33.9 0 0012.9 2.4V95a65.8 65.8 0 01-19.9-3.2z" />
                </svg>
              </Box>
            </Box>
          </Grid>
        </Grid>

      </Box>
    </Box>
  );
};

export default Footer;
